// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__HdrMP","rootCenter":"LoadMoreObserver_rootCenter__18HE6","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__Hd7u7"};